module.exports = __webpack_public_path__ + "img/16_29.12313bbf.png";